import { render, staticRenderFns } from "./IpjForm.vue?vue&type=template&id=79973a7e"
import script from "./IpjForm.vue?vue&type=script&lang=js"
export * from "./IpjForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports